import React, { useState } from 'react'
import Select from "react-select"
import Creatable from "react-select/creatable"
import { Link, Switch, Route } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Dropdown, Select as AntSelect, Menu, Popover, Badge } from 'antd'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'
import { BiSelectMultiple } from 'react-icons/bi'
import { FaHandHolding } from 'react-icons/fa'

import RecordSpoilage from '../components/modals/recordspoilage'
import ModifyQuantity from '../components/modals/modifyquantity'
import RestockItem from '../components/modals/restockitem'
import RestockOpen from '../components/modals/restockOpen'
import DispenseItems from '../components/modals/dispenseItems'
import Receive from '../components/resusable/receive'
import EditInventoryItem from '../components/modals/editInventoryItem'

import { useToggle, useListData, usePet, useSocketEvents } from '../modules'
import { addItemToAccQueue, clearAccQueue, removeAccItem } from '../store/actions'
import ItemRequests from '../components/drawers/itemRequests'
import ItemHistory from '../components/drawers/itemHistory'

const { Option } = AntSelect

const Store = () => {
    const { user } = useSelector(state => state.application)
    const { queue } = useSelector(state => state.accounting)

    const dispatch = useDispatch()

    const [selected, setSelected] = useState(null)
    const [string, setString] = useState('')
    const [storeName, setStoreName] = useState('')
    const [stores, setStores] = useState([])
    const [categories, setCategories] = useState([])
    const [category, setCategory] = useState({ label: 'All', value: 'All' })
    const [requests, setRequests] = useState(0)
    const [store, setStore] = useState()

    // const { option, setOption, dropdown } = useDropDown(['Select', 'Delete', 'Renew'])

    const [restockModal, toggleRestockModal] = useToggle()
    const [modifyQuantityModal, toggleModifyQuantityModal] = useToggle()
    const [inventoryItemModal, toggleInventoryItemModal] = useToggle()
    const [spoilageModal, toggleSpoilageModal] = useToggle()
    const [dispenseModal, toggleDispenseModal] = useToggle()
    const [invEdit, toggleInvEdit] = useToggle()
    const [request, toggleRequest] = useToggle()
    const [selectMode, toggleSelectMode] = useToggle(queue.length > 0)

    usePet('inventoryCategories', null, { notify: true, callback: ({ data }) => setCategories(data) })
    const [, getSaleItem] = usePet('saleItemByInvItem', { id: selected?._id }, { notify: true, callback: ({ data }) => dispatch(addItemToAccQueue(selected.item, data.price)), manual: true })

    const [, getRequests] = usePet('requestsByStore', { store: store?.value, type: "Received", classif: 'Pending' }, { notify: true, manual: true, callback: ({ data }) => setRequests(data.count) })

    const restock = itm => {
        setSelected(itm)
        toggleRestockModal()
    }

    const spoilage = itm => {
        setSelected(itm)
        toggleSpoilageModal()
    }

    const modifyQty = itm => {
        setSelected(itm)
        toggleModifyQuantityModal()
    }

    const edit = itm => {
        setSelected(itm)
        toggleInvEdit()
    }

    const chooseItem = itm => {
        let i = queue.findIndex(e => e.item._id === itm.item._id)
        if (i >= 0) {
            dispatch(removeAccItem(i))
        } else {
            setSelected(itm)
            getSaleItem()
        }
    }

    const [
        { loading: invLoading, error: invError, fetch }, 
        { list: inventory = [] }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('inventory', {
        store: store?.value,
        category: category?.value !== 'All' ? category?.value : undefined,
        string
    }, { notify: true, manual: true })

    const refresh = () => {
        fetch()
        getRequests()
        navigate(1)
    }

    useSocketEvents({
        'new-request': {
            condition: data => data.store === 'Pharmacy',
            notif: {
                message: 'New Request',
                type: 'info'
            },
            callback: getRequests
        }
    })
    
    const [{ loading: alLoading, error: alError }, getAllowed] = usePet('myAllowedStores', {
        name: storeName
    }, { notify: true, callback: ({ data }) => {
        let allowed = data?.map(st => ({
            ...st,
            label: st?.store?.name,
            value: st?.store?._id,
            permissions: st?.permissions
        }))

        if (allowed?.length > 0) {
            setStores(allowed)
            setStore(allowed[0])
            refresh()
        }
    } })
    
    const [{ loading: stoLoading }, newStore] = usePet('newStore', {
        name: storeName
    }, { notify: true, callback: getAllowed, manual: true, load: { msg: 'Adding store...' } })

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            refresh()
    }

    const selectStore = val => {
        setStore(val)
        refresh()
    }

    const selectCategory = val => {
        setCategory(val)
        refresh()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <ModifyQuantity
                store={store}
                onPerform={fetch}
                record={ selected }
                toggle={toggleModifyQuantityModal}
                visible={modifyQuantityModal} />
            <RestockOpen
                store={store}
                onPerform={fetch}
                toggle={toggleInventoryItemModal}
                visible={inventoryItemModal} />
            <RestockItem
                store={store}
                onPerform={fetch}
                record={ selected }
                toggle={toggleRestockModal}
                visible={restockModal} />
            <RecordSpoilage
                store={store}
                onPerform={fetch}
                record={ selected }
                toggle={toggleSpoilageModal}
                visible={spoilageModal} />
            <DispenseItems
                store={store}
                onPerform={fetch}
                toggle={toggleDispenseModal }
                visible={ dispenseModal } />
            {
                invEdit &&
                <EditInventoryItem
                    onPerform={fetch}
                    item={ selected?.item }
                    toggle={toggleInvEdit }
                    visible={ invEdit } />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" />
                <div className="grid grid-flow-col sm:auto-cols-max items-center justify-center sm:justify-end gap-2">
                    <input
                        onChange={ e => search(e.target.value) }
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-inv-item"
                        type="text"
                        placeholder="Type to search items" />
                    {/* <Select
                        value={ store }
                        onChange={ selectStore }
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                        options={ stores }
                        placeholder="Select Store" /> */}
                    {
                        (user?.issuperuser || user.stations?.some(st => st.name === 'store' && (st.permissions.includes('edit-items') || st.permissions.includes('*')))) &&
                        <button onClick={ () => toggleInventoryItemModal() } className="btn hisani-btn-green-light text-white">
                            <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                            </svg>
                            <span className="hidden xs:block ml-2">Add Item</span>
                        </button>
                    }
                    {
                        (store?.permissions?.includes('*') || store?.permissions?.includes('handle-requests') || user?.issuperuser) &&
                        <Badge count={ requests }>
                            <Link to={ `/app/inventory/requests/${store?.value}` }>
                                <button className="btn flex items-center hisani-btn-green-light text-white">
                                    <FaHandHolding />
                                    <span className="hidden xs:block ml-2">Requests</span>
                                </button>
                            </Link>
                        </Badge>
                    }
                    {
                        queue.length > 0 ?
                        <Dropdown
                            overlay={
                                <Menu>
                                    <Menu.Item onClick={ () => {
                                        dispatch(clearAccQueue())
                                        toggleSelectMode()
                                     } }>Deselect All</Menu.Item>
                                    <Menu.Item onClick={ toggleRequest }>Request Items</Menu.Item>
                                </Menu>
                            }>
                            <button className="btn hisani-btn-green-light text-white">
                                <span className="hidden xs:block mr-2">Actions ({ queue.length })</span>
                                <AiOutlineDown />
                            </button>
                        </Dropdown>
                        :
                        <button onClick={ () => toggleSelectMode() } className="btn hisani-btn-green-light text-white">
                            <BiSelectMultiple style={{ color: "white" }} />
                            <span className="hidden xs:block ml-2">{ selectMode ? 'Deselect' : 'Select' }</span>
                        </button>
                    }
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Inventory</h2>
                    <span className="flex items-center justify-between">
                        <Select
                            value={category}
                            onChange={selectCategory}
                            className="mr-2"
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={ [{ label: 'All', value: 'All' }, ...categories.map(cat => ({ label: cat, value: cat }))] }
                            placeholder="Select Category" />
                        {
                            (user?.issuperuser || user?.stations?.some(st => st.name === 'store' && st.permissions.includes('create-stores'))) ?
                                <Creatable
                                    value={store}
                                    onChange={selectStore}
                                    onCreateOption={ val => {
                                        setStoreName(val)
                                        newStore()
                                    }}
                                    styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                    options={ stores }
                                    placeholder="Select Or Add New Store" />
                                :
                                <Select
                                    value={store}
                                    onChange={selectStore}
                                    styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                    options={ stores }
                                    placeholder="Select Store" />
                        }
                        <button onClick={ refresh } className="btn ml-2 py-2.5 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        error={alError}
                        loading={invLoading}
                        progress>
                        {
                            store ?
                                <div className="overflow-x-auto">
                                    <Receive
                                        error={invError}
                                        loading={invLoading}
                                        progress>
                                        {
                                            inventory?.length > 0 ?
                                                <table className="table-auto w-full">
                                                    {/* Table header */}
                                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                        <tr>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-center">No</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Item</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-center">Category</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-center">Quantity</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-center"></div>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    {/* Table body */}
                                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                        {
                                                            inventory.map((rec, key) =>
                                                                <tr>
                                                                    <td className="p-2">
                                                                        <div className="text-center">
                                                                            {
                                                                                selectMode ?
                                                                                    <input
                                                                                        onChange={() => chooseItem(rec)}
                                                                                        checked={ queue.some(e => e.item._id === rec.item._id) }
                                                                                        type="checkbox"
                                                                                        className="form-checkbox cursor-pointer h-5 w-5" />
                                                                                :
                                                                                    `${((page - 1) * limit) + key + 1}.`
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="">{rec.item.name}</div>
                                                                        {
                                                                            rec?.item?.code &&
                                                                            <p className="text-gray-500 text-xs italic">{rec?.item?.code}</p>
                                                                        }
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="text-center">{rec.item.category}</div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="text-center">{rec.variations.reduce((total, variant) => total + variant.total, 0)} {rec.item.issuedIn}</div>
                                                                    </td>
                                                                    <td className="p-2 text-center">
                                                                        <Dropdown
                                                                            overlay={() => {
                                                                                let override = store?.permissions?.includes('*') || user?.issuperuser

                                                                                return (
                                                                                    <Menu>
                                                                                        {
                                                                                            (user?.issuperuser || (user.stations?.some(st => st.name === 'store' && (st.permissions.includes('edit-items') || st.permissions.includes('*'))))) &&
                                                                                            <Menu.Item onClick={ () => edit(rec) }>View</Menu.Item>
                                                                                        }
                                                                                        {
                                                                                            (store?.permissions?.includes('restock-items') || override) &&
                                                                                            <Menu.Item onClick={ () => restock(rec) }>Restock Item</Menu.Item>
                                                                                        }
                                                                                        {
                                                                                            (store?.permissions?.includes('move-stock') || override) &&
                                                                                            <Menu.Item onClick={ () => restock(rec) }>Move to Another Store</Menu.Item>
                                                                                        }
                                                                                        {
                                                                                            (store?.permissions?.includes('modify-quantity') || override) &&
                                                                                            <Menu.Item onClick={ () => modifyQty(rec)}>Modify Quantity</Menu.Item>
                                                                                        }
                                                                                        {
                                                                                            (store?.permissions?.includes('view-history') || override) &&
                                                                                            <Menu.Item><Link className="text-gray-600 hover:text-gray-600" to={ `/app/inventory/history/${rec?.item?._id }/${store?.value}` }>View History</Link></Menu.Item>
                                                                                        }
                                                                                        {
                                                                                            (store?.permissions?.includes('record-spoilage-damage')) &&
                                                                                            <Menu.Item onClick={ () => spoilage(rec) }>Record Spoilage/Damage</Menu.Item>
                                                                                        }
                                                                                    </Menu>

                                                                                )
                                                                            }}>
                                                                            <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            :
                                                <div className="w-full h-16 flex items-center justify-center">
                                                    <p className="font-semibold text-base">No items were found</p>
                                                </div>
                                        }
                                    </Receive>
                                    { Paginate }
                                </div>
                            :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">Please select a store</p>
                                </div>
                        }
                    </Receive>
                </div>
            </div>
            <Switch>
                <Route path="/app/inventory/requests/:id">
                    <ItemRequests path="/app/inventory" />
                </Route>
                <Route path="/app/inventory/history/:id/:store">
                    <ItemHistory onClose={ refresh } />
                </Route>
            </Switch>
        </div>
    )
}

export default Store